<template>
  <div 
    class="fill-height">
    <v-layout wrap>
      <v-flex>
        <section>
          <v-row
            class="pa-4 pb-2 pr-1">
            <v-col
              cols="12">
              <v-card
                to="/pembelian/supplier-item"
                flat
                color="transparent"
                style="width: 100%;">
                <div
                  class="d-flex align-center">
                  <v-avatar
                    tile
                    size="28"
                    style="opacity: 30%;">
                    <v-img
                      contain
                      alt="POS Amanata"  
                      :src="require('@/assets/icon/back_arrow.png')">
                      <template v-slot:placeholder>
                        <v-row
                          class="fill-height"
                          align="center"
                          justify="center">
                          <v-progress-circular 
                            size="20"
                            indeterminate 
                            :color="set_color">
                          </v-progress-circular>
                        </v-row>
                      </template>
                    </v-img>
                  </v-avatar>

                  <span
                    class="title black--text ml-3"
                    style="font-weight: 600;">
                    Tambah Item Supplier
                  </span>
                </div>
              </v-card>
            </v-col>
          </v-row>

          <v-row
            class="pa-4 pr-1">
            <v-col 
              cols="12"
              class="py-0">
              <v-card 
                flat
                min-height="calc(100vh - 245px)"
                style="border-radius: 10px; border: 1px solid #E7E7E7; overflow-y: auto;">
                <v-card-text>
                  <ValidationObserver 
                    ref="form">
                    <v-form>
                      <v-row>
                        <v-col
                          cols="12">
                          <ValidationProvider 
                            name="Supplier"
                            rules="required"  
                            v-slot="{ errors, valid }">
                            <div class="body-2 mb-2">
                              <span class="red--text">*</span>

                              Pilih Supplier
                            </div>

                            <v-autocomplete
                              v-on:keyup.enter="save()"

                              outlined
                              rounded
                              dense

                              :color="set_color"
                              placeholder="Contoh. Supplier"
                              v-on:change="selected.supplier = supplier.find(x => x.id === form.supplier_id)"

                              hide-details

                              :items="supplier"
                              item-text="name"
                              item-value="id"
                              :item-color="set_color"

                              v-model="form.supplier_id"
                              :error-messages="errors"
                              required
                              style="border-radius: 10px;">
                              <template v-slot:append-outer>
                                <div v-if="errors.length > 0">
                                  <v-tooltip top color="#ff5252">
                                    <template v-slot:activator="{ on }">
                                      <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                    </template>
                                    
                                    {{ errors[0] }}
                                  </v-tooltip>
                                </div>
                                
                                <div v-if="form.supplier_id !== '' && valid">
                                  <v-icon color="success">mdi-check-circle-outline</v-icon>
                                </div>
                              </template>
                            </v-autocomplete>
                          </ValidationProvider>
                        </v-col>

                        <v-col cols="12" v-if="Object.keys(selected.supplier).length > 0">
                          <v-card flat 
                            style="border: 2px dashed #e0e0e0; border-radius: 10px;">
                            <v-card-text
                            class="py-3 line-text-second">
                            <div
                              class="d-flex align-center">
                              <div style="width: 150px;">Nama</div> : {{ selected.supplier.name }}
                            </div>

                            <div
                              class="d-flex align-center">
                              <div style="width: 150px;">Email</div> : {{ selected.supplier.email }}
                            </div>

                            <div
                              class="d-flex align-center">
                              <div style="width: 150px;">Mobilephone</div> : {{ selected.supplier.mobilephone }}
                            </div>

                            <div
                              class="d-flex align-center">
                              <div style="width: 150px;">PIC Nama</div> : {{ selected.supplier.pic_name }}
                            </div>

                            <div
                              class="d-flex align-center">
                              <div style="width: 150px;">PIC Email</div> : {{ selected.supplier.pic_email }}
                            </div>

                            <div
                              class="d-flex align-center">
                              <div style="width: 150px;">PIC Mobilephone</div> : {{ selected.supplier.pic_mobilephone }}
                            </div>

                            <div
                              class="d-flex align-center">
                              <div style="width: 150px;">Alamat</div> : {{ selected.supplier.address }}
                            </div>

                            <!-- <div
                              class="d-flex align-center">
                              <div style="width: 50px;">Url</div> : <a :href="form.filename" target="_blank" class="ml-1">{{ form.filename }}</a>
                            </div> -->
                          </v-card-text>
                          </v-card>
                        </v-col>

                        <v-col
                          cols="12">
                          <ValidationProvider 
                            name="Item"
                            rules="required"  
                            v-slot="{ errors, valid }">
                            <div class="body-2 mb-2">
                              <span class="red--text">*</span>

                              Pilih Item
                            </div>

                            <v-autocomplete
                              v-on:keyup.enter="save()"

                              outlined
                              rounded
                              dense

                              :color="set_color"
                              placeholder="Contoh. Item"

                              hide-details

                              :items="item"
                              item-text="name"
                              item-value="id"
                              :item-color="set_color"
                              v-on:change="selected.item = item.find(x => x.id === form.item_id)"

                              v-model="form.item_id"
                              :error-messages="errors"
                              required
                              style="border-radius: 10px;">
                              <template v-slot:append-outer>
                                <div v-if="errors.length > 0">
                                  <v-tooltip top color="#ff5252">
                                    <template v-slot:activator="{ on }">
                                      <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                    </template>
                                    
                                    {{ errors[0] }}
                                  </v-tooltip>
                                </div>
                                
                                <div v-if="form.item_id !== '' && valid">
                                  <v-icon color="success">mdi-check-circle-outline</v-icon>
                                </div>
                              </template>
                            </v-autocomplete>
                          </ValidationProvider>
                        </v-col>

                        <v-col cols="12" v-if="Object.keys(selected.item).length > 0">
                          <v-card flat 
                            style="border: 2px dashed #e0e0e0; border-radius: 10px;">
                            <v-card-text
                            class="py-3 line-text-second">
                            <div
                              class="d-flex align-center">
                              <div style="width: 150px;">Nama</div> : {{ selected.item.name }}
                            </div>

                            <div
                              class="d-flex align-center">
                              <div style="width: 150px;">Kategori Item</div> : {{ selected.item.category_item_name }}
                            </div>

                            <div
                              class="d-flex align-center">
                              <div style="width: 150px;">Satuan</div> : {{ selected.item.satuan }}
                            </div>

                            <div
                              class="d-flex align-center">
                              <div style="width: 150px;">Harga Beli</div> : {{ selected.item.purchase_price | price }}
                            </div>

                            <div
                              class="d-flex align-center">
                              <div style="width: 150px;">Deskripsi</div> : {{ selected.item.desc }}
                            </div>

                            <div
                              class="d-flex align-center">
                              <div style="width: 150px;">Catatan</div> : {{ selected.item.note }}
                            </div>

                            <!-- <div
                              class="d-flex align-center">
                              <div style="width: 50px;">Url</div> : <a :href="form.filename" target="_blank" class="ml-1">{{ form.filename }}</a>
                            </div> -->
                          </v-card-text>
                          </v-card>
                        </v-col>

                      </v-row>

                      <v-row>
                        
                      </v-row>

                    </v-form>
                  </ValidationObserver>

                  <div v-if="message.error.length > 0"
                    class="text-center my-4 d-flex align-center">
                    <div
                      class="error--text">
                      <v-icon size="18" color="red">mdi-alert-circle-outline</v-icon>
                      
                      <span
                        class="ml-1">
                        {{ message.error }}
                      </span>
                    </div>
                  </div>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>

          <v-row
            justify="end"
            class="pa-4 pr-1">
            <v-col 
              cols="12"
              md="12"
              class="d-flex align-center justify-end py-0">
              <v-btn
                @click="save()"
                :loading="process.form"
                :disabled="process.form"
                elevation="0"
                color="#240087"
                class="body-2 white--text text-capitalize border-radius">
                <v-icon
                  size="20">
                  mdi-checkbox-marked-circle-outline
                </v-icon>

                <span
                  class="ml-2">
                  Simpan
                </span>
              </v-btn>
              
              <v-btn
                to="/pembelian/supplier-item"
                :disabled="process.form"
                color="red"
                elevation="0"
                class="body-2 white--text text-capitalize d-flex align-center ml-4"
                style="border-radius: 10px; font-weight: 600;">
                <v-icon 
                  size="20">
                  mdi-progress-close
                </v-icon>

                <span
                  class="ml-2">
                  Batal
                </span>
              </v-btn>
            </v-col>
          </v-row>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { get, post, put, patch, destroy } from "@/service/Axios";
  import moment from "moment"
  import "moment/locale/id"
  export default {
    data () {
      return {
        supplier: [],
        item: [],
        detail: {},

        form: {
          supplier_id: '',
          item_id: '',
          id: ''
        },
        selected: {
          supplier: {},
          item: {}
        },
        show: false,
        upload: {
          image: null
        },

        process: {
          form: false,

          image: false
        },
        
        message: {
          success: '',
          error: ''
        }
      }
    },
    components: {
      uploadfolder: () => import(/* webpackPrefetchCategory: true */ '@/components/upload/folder.vue')
    },
    watch: {
      
    },
    computed: {
      user () {
        return this.$store.state.user
      },
      outlet () {
        return this.$store.state.outlet
      },
      rps () {
        return this.$vuetify.breakpoint.name
      },
      fcm () {
        return this.$store.state.fcm
      },
      isDay () {
        let hours = (new Date()).getHours(),
            day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
        return day
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.25)`
      }
    },
    mounted () {
      this.fetchDetail()
    },
    methods: {
      async fetchDetail () {
        let params = {
          id: this.$route.params.id
        }

        await get(`pos/pembelian/item_supplier/detail`, { params })
        .then(response => {
          let res = response.data

          if (res.status === 200) {
            this.detail = res.results.data
            this.form.id = this.detail.id
            this.form.supplier_id = this.detail.supplier_id
            this.form.item_id = this.detail.item_id
            this.fetch()
            this.fetchItem()
          }
        })
      },
      async fetch () {
        let params = {
          limit: 1000000,
        }
        
        await get('pos/pembelian/supplier/data', { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            this.supplier = res.results.data

            if (this.form.supplier_id !== '') {
              this.selected.supplier = this.supplier.find(x => x.id === this.form.supplier_id)
            }
          }
        })
      },

      async fetchItem () {
          let params = {
          limit: 100000000000,
          outlet_id: this.outlet.outlet_id
        }

        await get(`pos/pembelian/item/data`, { params })
        .then(response => {
          let res = response.data

          if (res.status === 200) {
            this.item = res.results.data
            if (this.form.item_id !== '') {
              this.selected.item = this.item.find(x => x.id === this.form.item_id)
            }
          }
        })
      },

      async save () {
        this.message.error = ''

        const isValid = await this.$refs.form.validate()
        if (isValid) {
          this.process.form = true

          // SAVE TO REST API
          await post(`pos/pembelian/item_supplier/update`, {
            data: this.form
          })
          .then((response) => {
            let res = response.data

            this.process.form = false

            if (res.status === 200) {

              this.$router.push({ path: '/pembelian/supplier-item' })

            } else {
              this.message.error = res.message
            }
          })
          
        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }
      }
    }
  }
</script>